<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                Administration des concerts
            </h1>
            <ol class="breadcrumb">
                <li><router-link :to="{ name: 'dashboard' }"><i class="fa fa-music"> Gestion des concerts</i></router-link></li>
                <li v-if="$route.params.id" class="active">Modifier</li>
                <li v-else class="active">Nouveau</li>
            </ol>
        </section>

        <div v-if="error" class="alert alert-danger">
            <a class="close" data-dismiss="alert">&times;</a>
            {{ error }}
        </div>

        <!-- Main content -->
        <section class="content">
            <!-- Default box -->
            <div class="box">
                <div class="box-header with-border">
                    <h3 v-if="$route.params.id" class="box-title">Edition d'un concert</h3>
                    <h3 v-else class="box-title">Création d'un concert</h3>
                </div>
                <div class="box-body">
                    <form v-on:submit.prevent="addConcert" class="form-horizontal" id="new-concert">
                        <div class="form-group">
                            <label for="name" class="col-sm-2 control-label">Nom du concert</label>
                            <div class="col-sm-10">
                                <input type="text" v-model="concert.name" class="form-control" name="name" id="name">
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="organizer" class="col-sm-2 control-label">Organisateur</label>
                            <div class="col-sm-10">
                                <select v-model="concert.organizer" class="form-control" name="organizer" id="organizer">
                                    <option v-for="organizer in organizers" v-bind:value="organizer.id">{{ organizer.name }}</option>
                                </select>
                                <a href="#" data-toggle="modal" data-target="#organizer-create-modal">Créer un nouvel organisateur</a>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="day" class="col-sm-2 control-label">Jour</label>
                            <div class="col-sm-4">
                                <input type="date" v-model="concert.day" class="form-control" name="day" id="day">
                            </div>
                            <label for="hour" class="col-sm-1 control-label">Heures</label>
                            <div class="col-sm-2">
                                <input type="number" min="0" max="24" v-model="concert.hours" class="form-control" name="hour" id="hour">
                            </div>
                            <label for="minutes" class="col-sm-1 control-label">Minutes</label>
                            <div class="col-sm-2">
                                <input type="number" min="0" max="45" step="15" v-model="concert.minutes" class="form-control" name="hour" id="minutes">
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="place" class="col-sm-2 control-label">Lieu</label>
                            <div class="col-sm-10">
                                <select v-model="concert.address" class="form-control" name="place" id="place">
                                    <option value="0">Choisissez une adresse</option>
                                    <option v-for="address in addresses" v-bind:value="address.id">{{ address.name }} ({{ address.address }} - {{ address.zipcode }} {{ address.city }})</option>
                                </select>
                                <a href="#" data-toggle="modal" data-target="#address-create-modal">Créer une nouvelle adresse ?</a>
                            </div>
                        </div>
                        <fieldset id="tickets-fields">
                            <legend>Billets</legend>
                            <div class="form-group">
                                <label for="price_category" class="col-sm-2 control-label">Ajouter un tarif</label>
                                <div class="col-sm-10">
                                    <select v-on:change="addPriceCategory" v-model="priceCategory" id="price_category" class="form-control">
                                        <option value="0">Choisissez un tarif</option>
                                        <option v-for="(category, index) in categories" v-bind:value="index">{{ category.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">Catégorie</div>
                                <div class="col-sm-4">Tarif</div>
                                <div class="col-sm-4">Quantité</div>
                            </div>
                            <div v-for="(category, index) in concert.categories" class="form-group margin10">
                                <label class="control-label col-sm-4">{{ category.name }}</label>
                                <div class="col-sm-3">
                                    <input type="number" min="0.00" step="0.01" v-model="category.amount" class="form-control" placeholder="Tarif">
                                </div>
                                <div class="col-sm-3">
                                    <input type="number" min="0" v-model="category.quantity" class="form-control" placeholder="Quantité">
                                </div>
                                <div class="col-sm-2">
                                    <a v-on:click.prevent="removePriceCategory(index)" href="#" title="Retirer"><i class="fa fa-times"></i></a>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="checkbox-group required">
                            <legend>Modes d'envoi</legend>
                            <div v-for="mode in modes" class="checkbox">
                                <label>
                                    <input type="checkbox" v-model="concert.modes" v-bind:value="mode.id"> {{ mode.type }}
                                </label>
                            </div>
                        </fieldset>
                        <div class="form-group margin10">
                            <label for="safe-delay" class="col-sm-2 control-label">Délai de sécurité (en heures)</label>
                            <div class="col-sm-10">
                                <input type="number" v-model="concert.delay" min="0" placeholder="En heures" class="form-control" name="name" id="safe-delay">
                            </div>
                        </div>
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" v-model="concert.active"> Concert disponible en ligne
                            </label>
                        </div>
                        <div class="margin10">
                            <button v-if="$route.params.id" class="btn btn-primary">Modifier</button>
                            <button v-else class="btn btn-primary">Créer</button>
                        </div>
                    </form>
                </div>
            </div>
            <!-- /.box -->

        </section>
        <!-- /.content -->
        <!-- Modal -->
        <div class="modal fade" id="address-create-modal" tabindex="-1" role="dialog" aria-labelledby="Créer nouvelle adresse">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Ajouter une nouvelle adresse</h4>
                    </div>
                    <div class="modal-body">
                        <form method="post" action="">
                            <div class="form-group">
                                <label class="control-label" for="address-name">Nom du lieu</label>
                                <input v-model="address.name" type="text" class="form-control" id="address-name" name="name">
                            </div>
                            <div class="form-group">
                                <label class="control-label" for="address">Adresse</label>
                                <input v-model="address.address" type="text" class="form-control" id="address" name="address">
                            </div>
                            <div class="form-group">
                                <label class="control-label" for="zipcode">Code postal</label>
                                <input v-model="address.zipcode" type="text" class="form-control" id="zipcode" name="zipcode">
                            </div>
                            <div class="form-group">
                                <label class="control-label" for="city">Ville</label>
                                <input v-model="address.city" type="text" class="form-control" id="city" name="city">
                            </div>
                            <div class="form-group">
                                <label class="control-label" for="country">Pays</label>
                                <input v-model="address.country" type="text" class="form-control" id="country" name="country">
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Annuler</button>
                        <button v-on:click.prevent="addAddress" type="button" class="btn btn-primary">Enregistrer</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="organizer-create-modal" tabindex="-1" role="dialog" aria-labelledby="Créer nouvel organisateur">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Ajouter un nouvel organisateur</h4>
                    </div>
                    <div class="modal-body">
                        <form method="post" action="">
                            <div class="form-group">
                                <label class="control-label" for="organizer-name">Nom de l'organisateur</label>
                                <input v-model="organizer.name" type="text" class="form-control" id="organizer-name" name="name">
                            </div>
                            <div class="form-group">
                                <label class="control-label" for="legal-form">Statut</label>
                                <input v-model="organizer.legalForm" type="text" class="form-control" id="legal-form" name="legal_form">
                            </div>
                            <div class="form-group">
                                <label class="control-label" for="siret">Siret</label>
                                <input v-model="organizer.siret" type="text" class="form-control" id="siret" name="siret">
                            </div>
                            <div class="form-group">
                                <label for="place" class="control-label">Adresse</label>
                                <select v-model="organizer.address" class="form-control" name="organizer-place" id="organizer_place">
                                    <option value="0">Choisissez une adresse</option>
                                    <option v-for="address in addresses" v-bind:value="address.id">{{ address.name }} ({{ address.address }} - {{ address.zipcode }} {{ address.city }})</option>
                                </select>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Annuler</button>
                        <button v-on:click.prevent="addOrganizer" type="button" class="btn btn-primary">Enregistrer</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .margin10 {
        margin-top: 10px;
    }
    #new-concert label {
        text-align: left;
    }
    #new-concert label:first-letter {
        text-transform: capitalize;
    }
</style>

<script>
  export default {
    name: 'DashboardCreate',
    data: function () {
      return {
        addresses: [],
        organizers: [],
        concert: {
          name: '',
          address: 0,
          organizer: 0,
          modes: [],
          active: false,
          day: '',
          hours: 12,
          minutes: 0,
          delay: 0,
          categories: []
        },
        tickets: [],
        address: {
          name: '',
          address: '',
          zipcode: '',
          city: '',
          country: 'France'
        },
        organizer: {
          name: '',
          legalForm: '',
          siret: '',
          address: 0
        },
        modes: [],
        categories: [],
        priceCategory: 0,
        error: ''
      }
    },
    created: function () {
      if (this.$route.params.id) {
        this.$http.get('http://ws.ojssymphonique.net/api/concerts/' + this.$route.params.id + '?token=' + localStorage.getItem('token')).then((response) => {
          let date = new Date(response.body.concert.event_day)
          let dateFormat = require('dateformat')
          this.concert = {
            id: response.body.concert.id,
            name: response.body.concert.name,
            active: parseInt(response.body.concert.active),
            address: response.body.concert.address_id,
            organizer: response.body.concert.organizer_id,
            delay: response.body.concert.safe_delay,
            day: dateFormat(date, 'yyyy-mm-dd'),
            hours: date.getHours(),
            minutes: date.getMinutes(),
            modes: response.body.modes,
            categories: response.body.categories
          }
        })
      }

      this.$http.get('http://ws.ojssymphonique.net/api/categories').then(function (response) {
        this.categories = response.body
      })

      this.$http.get('http://ws.ojssymphonique.net/api/addresses?token=' + localStorage.getItem('token')).then(function (response) {
        this.addresses = response.body
      })
      this.$http.get('http://ws.ojssymphonique.net/api/organizers?token=' + localStorage.getItem('token')).then(function (response) {
        this.organizers = response.body
      })
      this.$http.get('http://ws.ojssymphonique.net/api/modes').then(function (response) {
        this.modes = response.body
      })
    },
    watch: {
      '$route': 'init'
    },
    methods: {
      init () {
        if (!this.$route.params.id) {
          this.concert = {
            name: '',
            address: 0,
            organizer: 0,
            modes: [],
            active: false,
            day: '',
            hours: 12,
            minutes: 0,
            delay: 0,
            categories: []
          }
        }
      },
      addAddress: function () {
        let newAddress = {
          name: this.address.name,
          address: this.address.address,
          zipcode: this.address.zipcode,
          city: this.address.city,
          country: this.address.country
        }
        this.$http.post('http://ws.ojssymphonique.net/api/addresses?token=' + localStorage.getItem('token'), newAddress).then((response) => {
          newAddress.id = response.body.id
          this.addresses.push(newAddress)
          this.concert.address = response.body.id
        })

        $('#address-create-modal').modal('hide')
      },
      addOrganizer: function () {
        let newOrganizer = {
          name: this.organizer.name,
          legalForm: this.organizer.legalForm,
          siret: this.organizer.siret,
          address: this.organizer.address
        }

        this.$http.post('http://ws.ojssymphonique.net/api/organizers?token=' + localStorage.getItem('token'), newOrganizer).then((response) => {
          newOrganizer.id = response.body.id
          this.organizers.push(newOrganizer)
          this.concert.organizer = response.body.id
        })

        $('#organizer-create-modal').modal('hide')
      },
      addConcert: function () {
        try {
          let checkboxFilled = $('.checkbox-group.required :checkbox:checked').length > 0
          if (!checkboxFilled) {
            throw new Error('Champs non complétés')
          }
        } catch (error) {
          this.error = error.message
          return
        }
        let date = new Date(this.concert.day)
        date.setHours(this.concert.hours)
        date.setMinutes(this.concert.minutes)

        let data = {
          name: this.concert.name,
          event_day: date.toString(),
          active: this.concert.active ? 1 : 0,
          safe_delay: this.concert.delay,
          organizer: this.concert.organizer,
          address: this.concert.address,
          modes: this.concert.modes,
          categories: this.concert.categories
        }

        if (this.$route.params.id) {
          this.$http.post('http://ws.ojssymphonique.net/api/concerts/' + this.$route.params.id + '?token=' + localStorage.getItem('token'), data).then((response) => {
            this.$router.push({ name: 'dashboard' })
          }).catch((response) => {
            this.error = 'Il y a des erreurs sur le formulaire'
          })
        } else {
          this.$http.post('http://ws.ojssymphonique.net/api/concerts?token=' + localStorage.getItem('token'), data).then((response) => {
            this.$router.push({ name: 'concerts.show', params: { id: response.body.id } })
          }).catch((response) => {
            this.error = 'Il y a des erreurs sur le formulaire'
          })
        }
      },
      addPriceCategory: function () {
        this.concert.categories.push(this.categories[this.priceCategory])
      },
      removePriceCategory: function (i) {
        this.concert.categories.splice(i, 1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Create.vue?be912e4e